import FormPrisma from "./Form"

export default function AddPrisma() {
    return (
        <FormPrisma />
    )
}